module.exports = __webpack_public_path__ + "img/figure3.0991f20d.png";